module.exports = __webpack_public_path__ + "static/media/no_ads_sept_2021_thumb.9bf767e8.jpg";